import { Field } from 'formik';
import { useRef, type RefObject } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { handleInputFileName } from 'utils/helpers/handleInputMaks';
import SolarIcon from 'components/icons/SolarIcon';

const ARTICLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export const generateRandomArticle = (): string => {
    let result = '';
    for (let i = 0; i < 5; i += 1) {
        result += ARTICLE_CHARS.charAt(Math.floor(Math.random() * ARTICLE_CHARS.length));
    }
    return result;
};

export interface FormArticleInputProps {
    label: string;
    /** Formik field name — якщо задано, рендерить Formik Field */
    name?: string;
    /** Controlled value — для форм без Formik */
    value?: string;
    /** Викликається при генерації (і при controlled onChange) */
    onChange: (value: string) => void;
    disabled?: boolean;
    /** Показувати кнопку генерації (режим створення) */
    canGenerate?: boolean;
    generateTitle?: string;
    inputRef?: RefObject<HTMLInputElement | null>;
    labelClassName?: string;
    className?: string;
}

const FormArticleInput = ({
    label,
    name,
    value,
    onChange,
    disabled = false,
    canGenerate = false,
    generateTitle,
    inputRef,
    labelClassName = 'form-label text-muted',
    className = 'mb-3',
}: FormArticleInputProps) => {
    const { t } = useTranslation(['common']);
    const localRef = useRef<HTMLInputElement>(null);
    const ref = inputRef || localRef;
    const btnTitle = generateTitle || t('generateArticle');

    return (
        <Form.Group className={className}>
            <label className={labelClassName}>{label}</label>
            <InputGroup>
                {name ? (
                    <Field
                        innerRef={ref}
                        disabled={disabled}
                        name={name}
                        className="form-control"
                        onInput={() => handleInputFileName(ref)}
                    />
                ) : (
                    <Form.Control
                        ref={ref}
                        disabled={disabled}
                        value={value ?? ''}
                        onChange={(e) => onChange(e.target.value)}
                        onInput={() => handleInputFileName(ref)}
                    />
                )}
                {canGenerate && (
                    <Button
                        type="button"
                        variant="outline-secondary"
                        disabled={disabled}
                        title={btnTitle}
                        aria-label={btnTitle}
                        onClick={() => onChange(generateRandomArticle())}
                    >
                        <SolarIcon name="stars" />
                    </Button>
                )}
            </InputGroup>
        </Form.Group>
    );
};

export default FormArticleInput;
